module.exports = __webpack_public_path__ + "img/coppercola_back.a7af284e.jpg";